import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Motion, spring } from 'react-motion';
import { manageTranslations as TranslationHelper } from '@morsedigital/i18n_helper';

const DateNavWrapper = ({ getRef, position, renderItems }) => (
  <Motion style={{ x: spring(position) }}>
    {({ x }) => (
      <ul
        className="date-list__inner"
        ref={el => {
          getRef(el);
        }}
        style={{ transform: `translateX(${x}px)` }}
      >
        {renderItems()}
      </ul>
    )}
  </Motion>
);

DateNavWrapper.propTypes = {
  getRef: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
  renderItems: PropTypes.func.isRequired,
};

export default DateNavWrapper;
